import styles from './FullPageSpinner.module.css';

type Props = { label?: string };

export function FullPageSpinner({ label = 'Đang tải…' }: Props) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </div>
  );
}
